$(document).ready(function(){
   $.ajax({
     url:"/browsing_context_suggestions.json",
     dataType:'json',
     success:function(data){
       const country_code = data.detected_values.country.handle;
       console.log(`country = ${country_code}`)
       if(country_code == 'CA'){
            $('.product__custom-price').hide();
            $('.product__discount-message').hide();
            $('#shopify-section-announcement-bar').hide();
       }
     },
     error:function(error){
       console.log(error);
     }
   })
});